"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdpService = void 0;
const configuration_1 = require("@common/configuration");
const client_credential_service_1 = require("./base/client-credential.service");
const _ = require("lodash");
const connect_service_1 = require("./connect.service");
class IdpService extends client_credential_service_1.ClientCredentialService {
    constructor() {
        super(configuration_1.BackendConfiguration.idpServiceConfig());
        this.connectService = new connect_service_1.ConnectService();
    }
    async getOwners(filter) {
        try {
            const axios = await this.axiosInstance();
            const userResult = (await axios.get(`${this.apiUrl}/api/v1/users`, {
                params: { "filter[full_search]": filter, "filter[role]": IdpService.ownerRoleId, "page[size]": "200" },
            })).data.data;
            return this.processUsers(userResult);
        }
        catch (e) {
            this.logger.error("getOwners error", e);
            throw e;
        }
    }
    async getIdpUsersByEmail(email) {
        var _a;
        try {
            const axios = await this.axiosInstance();
            const userResult = (await axios.get(`${this.apiUrl}/api/v1/users`, {
                params: { "filter[email]": email, "page[size]": "1" },
            })).data.data;
            return (_a = this.processUsers(userResult)) === null || _a === void 0 ? void 0 : _a[0];
        }
        catch (e) {
            this.logger.error("getOwners error", e);
            throw e;
        }
    }
    async getUsers(filter) {
        try {
            const axios = await this.axiosInstance();
            const userResult = (await axios.get(`${this.apiUrl}/api/v1/users`, {
                params: { "filter[full_search]": filter, "page[size]": "200" },
            })).data.data;
            return this.processUsers(userResult);
        }
        catch (e) {
            this.logger.error("getOwners error", e);
            throw e;
        }
    }
    async getUserById(id) {
        try {
            const axios = await this.axiosInstance();
            const result = (await axios.get(`${this.apiUrl}/api/v1/users/${id}`)).data.data;
            return this.processUsers([result])[0];
        }
        catch (e) {
            this.logger.error("getUserById error", e);
            throw e;
        }
    }
    async linkUsers(linkAccount) {
        try {
            const axios = await this.axiosInstance();
            for (let userContact of linkAccount.linked_users) {
                const account_idp_user = await this.getUserById(userContact.idp_user_id);
                const account_connect_login = await this.connectService.getConnectLoginsByEmail(account_idp_user.attributes.email);
                if (account_idp_user.attributes.contact_ids.length >= 2) {
                    const unlinkedAccount = {
                        master_idp_user_id: userContact.idp_user_id,
                        master_contact_id: account_connect_login.attributes.contact_id,
                        linked_users: [],
                        applied_by: userContact.applied_by,
                    };
                    for (let contact of account_idp_user.attributes.contact_ids) {
                        const contact_login = (await this.connectService.getLoginsByContactsIds(`${contact}`))[0];
                        const contact_login_idp_user = await this.getIdpUsersByEmail(contact_login.attributes.email_address);
                        if (!_.isNil(contact_login) && !_.isNil(contact_login_idp_user)) {
                            unlinkedAccount.linked_users.push({
                                idp_user_id: contact_login_idp_user.id,
                                contact_id: contact,
                                state: true,
                                applied_by: userContact.applied_by,
                            });
                        }
                    }
                    if (unlinkedAccount.linked_users.length > 0) {
                        this.logger.info("unLinkUsers", { unlinkedAccount });
                        await this.unLinkUsers(unlinkedAccount);
                    }
                }
            }
            //remove contact id
            for (let account of linkAccount.linked_users) {
                await this.deleteContact(axios, account);
            }
            //insert contact ids
            const contacts = linkAccount.linked_users.map((userContact) => {
                return {
                    type: "UserContact",
                    id: userContact.contact_id,
                    idp_user_id: userContact.idp_user_id,
                    applied_by: userContact.applied_by,
                };
            });
            if (!_.isNil(linkAccount.master_contact_id)) {
                contacts.push({
                    type: "UserContact",
                    id: linkAccount.master_contact_id,
                    idp_user_id: linkAccount.master_idp_user_id,
                    applied_by: linkAccount.applied_by
                });
            }
            await axios.post(`${this.apiUrl}/api/v1/users/${linkAccount.master_idp_user_id}/relationships/contacts`, {
                data: contacts,
            });
            //remove owner role
            for (let account of linkAccount.linked_users) {
                await axios.delete(`${this.apiUrl}/api/v1/users/${account.idp_user_id}/relationships/roles`, {
                    data: {
                        data: [
                            {
                                type: "Role",
                                id: IdpService.ownerRoleId,
                            },
                        ],
                    },
                });
            }
            //disable user
            const disabledUsers = linkAccount.linked_users.filter((x) => !x.state);
            for (let disabledUser of disabledUsers) {
                await axios.patch(`${this.apiUrl}/api/v1/users/${disabledUser.idp_user_id}`, {
                    data: {
                        type: "User",
                        attributes: {
                            is_active: false,
                        },
                        id: disabledUser.idp_user_id,
                    },
                });
            }
            return await this.getUserById(linkAccount.master_idp_user_id);
        }
        catch (e) {
            this.logger.error("linkUsers error", e);
            throw e;
        }
    }
    async unLinkUsers(unlinkAccount) {
        try {
            const axios = await this.axiosInstance();
            //delete contact ids
            const contacts = unlinkAccount.linked_users.map((userContact) => {
                return {
                    type: "UserContact",
                    id: userContact.contact_id,
                    idp_user_id: userContact.idp_user_id,
                    applied_by: userContact.applied_by,
                };
            });
            await axios.delete(`${this.apiUrl}/api/v1/users/${unlinkAccount.master_idp_user_id}/relationships/contacts`, {
                data: { data: contacts },
            });
            // add contact ids to the original users
            for (let userContact of unlinkAccount.linked_users) {
                await axios.post(`${this.apiUrl}/api/v1/users/${userContact.idp_user_id}/relationships/contacts`, {
                    data: [
                        {
                            type: "UserContact",
                            id: userContact.contact_id,
                            idp_user_id: userContact.idp_user_id,
                            applied_by: userContact.applied_by
                        },
                    ],
                });
            }
            //add owner role
            for (let userContact of unlinkAccount.linked_users) {
                await axios.post(`${this.apiUrl}/api/v1/users/${userContact.idp_user_id}/relationships/roles`, {
                    data: [
                        {
                            type: "Role",
                            id: IdpService.ownerRoleId,
                        },
                    ],
                });
            }
            for (let linkedUser of unlinkAccount.linked_users) {
                await axios.patch(`${this.apiUrl}/api/v1/users/${linkedUser.idp_user_id}`, {
                    data: {
                        type: "User",
                        attributes: {
                            is_active: true,
                        },
                        id: linkedUser.idp_user_id,
                    },
                });
            }
            return await this.getUserById(unlinkAccount.master_idp_user_id);
        }
        catch (e) {
            this.logger.error("unLinkUsers error", e);
            throw e;
        }
    }
    processUsers(users) {
        var _a;
        for (const user of users) {
            user.attributes.is_owner = ((_a = user.relationships.roles.data.filter((x) => x.id == IdpService.ownerRoleId)) === null || _a === void 0 ? void 0 : _a.length) > 0;
        }
        return users;
    }
    async deleteContact(axios, userContact) {
        try {
            await axios.delete(`${this.apiUrl}/api/v1/users/${userContact.idp_user_id}/relationships/contacts`, {
                data: {
                    data: [
                        {
                            type: "UserContact",
                            id: userContact.contact_id,
                            idp_user_id: userContact.idp_user_id,
                            applied_by: userContact.applied_by,
                        },
                    ],
                },
            });
        }
        catch (e) {
            this.logger.error("no contact deleted", e);
        }
    }
}
exports.IdpService = IdpService;
IdpService.ownerRoleId = configuration_1.BackendConfiguration.idpRoles().Owner;
//# sourceMappingURL=idp.service.js.map